import { useContext } from 'react';
import { PageContext } from 'src/contexts/PageContext';

// ----------------------------------------------------------------------

const usePage = () => {
    const context = useContext(PageContext);
    if (!context) throw new Error('Page context must be use inside PageContextProvider');

    return context;
};

export default usePage;
